// Modal for picking which logbook a new entry goes in. Two callers, one
// decision -- the item has several logbooks of the right type (choose), none
// (offer to create), or the caller resolved it without asking.
//
// Task.jsx completes a Task into a Maintenance Log, and offers a third way out:
// complete the task without an entry at all. Trip.jsx / TripGroup.jsx copy a
// trip day into a Captain's Log, where there is nothing to skip -- the user
// asked to copy, and not copying is just Cancel. So `onSkip` is optional and
// its button appears only when a caller passes one.
//
// The wording props default to the Maintenance flow the modal was written for,
// so Task.jsx passes none of them.
//
// Props:
//   show        - visibility
//   onHide      - close without doing anything
//   logbooks    - the item's logbooks of the relevant type ([] when none)
//   onChoose(logbook) - user picked an existing logbook
//   onCreateNew()     - user wants to create a new logbook
//   onSkip()          - optional; omitted hides the skip button entirely
//   title       - modal heading
//   chooseText  - line above the list of logbooks
//   emptyText   - shown instead of the list when there are none
//   createLabel - label of the create-a-new-logbook button
//   skipLabel   - label of the skip button (only with onSkip)

import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

export const ChooseLogbookModal = ({
  show,
  onHide,
  logbooks = [],
  onChoose,
  onCreateNew,
  onSkip,
  title = 'Add to Logbook',
  chooseText = 'Choose a logbook for this entry:',
  emptyText = 'This item has no Maintenance Log yet. Create one to record this entry.',
  createLabel = 'New Maintenance Log',
  skipLabel = 'Complete without entry',
}) => (
  <Modal show={show} onHide={onHide}>
    <Modal.Header closeButton>
      <Modal.Title>{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {logbooks.length > 0 ? (
        <>
          <p className="text-body-secondary">{chooseText}</p>
          <div className="d-grid gap-2">
            {logbooks.map((logbook) => (
              <Button key={logbook.id} variant="outline-primary" onClick={() => onChoose(logbook)}>
                {logbook.name}
              </Button>
            ))}
          </div>
        </>
      ) : (
        <p className="text-body-secondary">{emptyText}</p>
      )}
    </Modal.Body>
    <Modal.Footer className="d-flex flex-wrap justify-content-between">
      <Button variant="success" onClick={onCreateNew}>
        <i className="fa-solid fa-plus me-1" aria-hidden="true"></i>
        {createLabel}
      </Button>
      <div className="d-flex gap-2">
        {onSkip && (
          <Button variant="outline-secondary" onClick={onSkip}>
            {skipLabel}
          </Button>
        )}
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
      </div>
    </Modal.Footer>
  </Modal>
);

export default ChooseLogbookModal;
